import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NoSpacesDirective } from './no-spaces.directive';
import { RegexValidatorDirective } from './regex-validator.directive';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    NoSpacesDirective,
    RegexValidatorDirective
  ],
  exports: [
    NoSpacesDirective,
    RegexValidatorDirective
  ]
})

export class DirectivesModule { }
